import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FeatureFlagData } from './feature-flag-data.model';
import {FeatureFlagsService} from "./feature-flags.service";

@Injectable()
export class FeatureFlagsInitializer {
  constructor(private http: HttpClient, private featureFlagsService: FeatureFlagsService) { }

  load(): Promise<any> {
    return this.http.get<FeatureFlagData[]>('/_support/feature/list')
      .toPromise().then(data => this.featureFlagsService.setFlags(data), error => console.error(error));
  }
}

